<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapState("newPurchase", ["to_be"]),
    ...mapGetters("newPurchase", ["duration", "price"])
  },

  methods: {
    ...mapActions("newPurchase", ["searchProfessionals"])
  }
};
</script>

<template>
  <div class="section">
    <div class="preview-schedule">
      {{duration}} HORAS DE LIMPEZA POR
      <span>{{price.formated}}</span>
      <p>Produtos de limpeza, transporte e alimentação do profissional inclusos.</p>
    </div>

    <div
      v-if="to_be === 'schedule'"
      class="btn bg-pink"
      @click="searchProfessionals(); $emit('scrollTo', '#professionals')"
    >buscar</div>
    <div v-else class="btn bg-pink" @click="$emit('scrollTo', '#informations')">confirmar</div>
  </div>
</template>

<style scoped>
.preview-schedule {
  font-size: 20px;
  font-weight: 600;
  margin-top: 20px;
  text-align: center;
}

.preview-schedule span,
.preview-schedule p {
  margin-top: 5px;
  color: var(--pink);
}

.preview-schedule p {
  font-size: 12px;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/OrdersAndSubscriptions/ConfirmPeriodPrice.vue